import { render, staticRenderFns } from "./BookersCalls.vue?vue&type=template&id=701f92da&scoped=true"
import script from "./BookersCalls.vue?vue&type=script&lang=js"
export * from "./BookersCalls.vue?vue&type=script&lang=js"
import style0 from "./BookersCalls.vue?vue&type=style&index=0&id=701f92da&prod&scoped=true&lang=css"
import style1 from "./BookersCalls.vue?vue&type=style&index=1&id=701f92da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f92da",
  null
  
)

export default component.exports